module.exports = __webpack_public_path__ + "img/dev_mac.c9e9658a.png";